import { trackPage } from 'lib/omniture';
import { pageTrackingSelector } from 'common/selectors/analyticsSelectors';
import { authStateKnown, providerInfoKnown } from 'lib/auth';
import { isEmpty } from 'lib/util';
import observeStore from './observeStore';

let initialPageTracked = false;
export default function trackingObserver(store) {
    return observeStore(store, pageTrackingSelector, (currentTracking = { page: {} }, nextTracking) => {
        const {
            isDomestic,
            adobePassInfo,
            analytics,
            app,
            ipInfo,
            page,
            userAuth,
            subscriptions,
            oneIdLoggedIn,
            entitlementsTracking,
            promoTracking,
            adobePassMetadata
        } = nextTracking;

        // this one makes sure we don't track the same page twice
        if (initialPageTracked && currentTracking.page.name === page.name) {
            return;
        }

        if (
            (
                analytics &&
                (authStateKnown(userAuth) || !userAuth.length) &&
                page.name &&
                providerInfoKnown(userAuth, adobePassInfo, ipInfo) &&
                (!isDomestic || ((subscriptions || !oneIdLoggedIn) && !isEmpty(entitlementsTracking)))
            ) || page.autoPageViewTrack
        ) {
            const provider = adobePassInfo || ipInfo || {};
            trackPage({ app, page, provider, userAuth, entitlementsTracking, promoTracking, adobePassMetadata, isDomestic });
            initialPageTracked = true;
        }
    });
};



// WEBPACK FOOTER //
// ./app/lib/observe/trackingObserver.js